export default "/_next/static/chunks/fonts/Roboto-BlackItalic-latin-f22b05420f6fc02e1bc47d5ff01069bf.woff2";